import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Box, Typography } from "@mui/material";
import { useLocation, Link as RouterLink } from "react-router-dom";
import { routesConfig } from "../services/routesConfig";
import { useNetworkContext } from "context/NetworkContext";
import { breadcrumbRootSx, breadcrumbTrailSx } from "./breadcrumbStyles";

interface ReportsLocationState {
  report?: {
    reportName?: string;
    value?: string;
  };
}

const reportBreadcrumbLabels: Record<string, string> = {
  networkActuals: "Network Actuals Report",
  showSchedule: "Show Schedule Report",
};

const getReportsDownloadBreadcrumbLabel = (reportState: ReportsLocationState | null) =>
  reportState?.report?.reportName ??
  (reportState?.report?.value ? reportBreadcrumbLabels[reportState.report.value] : undefined) ??
  "Network Actuals Report";

function Breadcrumb() {
  const location = useLocation();
  const { userRole } = useNetworkContext();
  const hideUI = !userRole || userRole === "no-access" || userRole === "new-user";

  if (hideUI) {
    return null;
  }

  const reportState = location.state as ReportsLocationState | null;
  const breadcrumbs =
    location.pathname === "/reports-download"
      ? [
          { path: "/reports", label: "Reports" },
          { path: "/reports-download", label: getReportsDownloadBreadcrumbLabel(reportState) },
        ]
      : location.pathname.split("/").reduce(
          (acc, pathSegment, index, arr) => {
            const path = arr.slice(0, index + 1).join("/");
            const route = routesConfig.find((route) => route.path === path);

            if (route) {
              acc.push({
                path,
                label: route.label,
              });
            }

            return acc;
          },
          [] as { path: string; label: string }[],
        );

  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <Box sx={breadcrumbRootSx}>
      <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" />} sx={breadcrumbTrailSx}>
        {breadcrumbs.map((breadcrumb, index) =>
          index === breadcrumbs.length - 1 ? (
            <Typography key={breadcrumb.path} color="text.primary" variant="body2" fontWeight={600}>
              {breadcrumb.label}
            </Typography>
          ) : (
            <Link key={breadcrumb.path} color="inherit" component={RouterLink} to={breadcrumb.path} underline="hover">
              {breadcrumb.label}
            </Link>
          ),
        )}
      </Breadcrumbs>
    </Box>
  );
}

export default Breadcrumb;
